var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOHeadBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 74,
    viewBox: "0 0 64 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 72.5589C1 72.5589 23.2904 73.1261 18.6054 50.6939C18.6054 50.6939 16.1448 46.907 16.0503 41.7021C16.0503 41.7021 12.3106 44.7772 10.609 33.2302C10.609 33.2302 8.14838 24.8057 13.9705 29.727C13.9705 29.727 11.4153 1.61439 31.4814 1.70893C31.4814 1.70893 54.1027 -1.98344 50.9331 28.8261C50.9331 28.8261 57.4642 22.484 53.7246 36.5389C53.7246 36.5389 52.2093 42.881 49.3705 41.8384C49.3705 41.8384 49.276 47.4242 46.7208 50.2629C46.7208 50.2629 40.3787 71.6553 63 72.128L1.00277 72.5534L1 72.5589Z",
    fill: "#F2F4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6054 50.6939C23.2904 73.1261 1 72.5589 1 72.5589L1.00277 72.5534M16.0503 41.7021C16.0503 41.7021 12.3106 44.7772 10.609 33.2302C10.609 33.2302 8.14838 24.8057 13.9705 29.727C13.9705 29.727 11.4153 1.61439 31.4814 1.70893C31.4814 1.70893 54.1027 -1.98343 50.9331 28.8261C50.9331 28.8261 57.4642 22.484 53.7246 36.5389C53.7246 36.5389 52.2093 42.881 49.3705 41.8384M63 72.128C44.843 71.7486 45.3456 57.8918 46.2511 52.4372",
    stroke: "#C3C7D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7546 59.6464C30.0799 59.6464 27.3162 58.7706 24.7248 57.069C19.9759 53.9521 16.6839 48.6583 15.9165 42.9112C15.7747 42.3607 10.0972 19.7366 18.127 8.27583C20.8351 4.4083 24.8138 2.20345 29.9547 1.71688C36.9002 1.05793 42.208 2.47314 45.7307 5.91805C52.4203 12.4575 51.5167 25.0166 50.9189 33.3272L50.8327 34.52C49.9347 47.4043 44.2376 56.8632 35.966 59.2071C34.9233 59.5018 33.8445 59.6492 32.7518 59.6492L32.7546 59.6464Z",
    fill: "#F2F4FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 38C16.4258 35.1135 13.5207 19.3914 20.3278 9.67559C25.1965 2.72258 37.6768 1.7587 43.7286 7.67681C49.3997 13.2206 50.1718 30.0881 47.5002 36.5C45.0002 42.5 39.6601 38.1379 33.5002 38C28.3422 37.8845 23.1741 42.68 19.0002 38Z",
    fill: "#3455FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0007 53L18.8952 51.0844C17.3453 48.6268 16.3059 45.8273 15.9165 42.9112C15.7747 42.3607 10.0972 19.7366 18.127 8.27583C20.8351 4.4083 24.8138 2.20345 29.9547 1.71688C36.9002 1.05793 42.208 2.47314 45.7307 5.91805C52.4203 12.4575 51.5167 25.0166 50.9189 33.3272L50.8327 34.52C50.4036 40.6767 48.8787 46.0513 46.5007 50.2411L46.2198 52.6193",
    stroke: "#C3C7D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOHeadBack);
export default __webpack_public_path__ + "static/media/o-head-back.e0a88a1e976fd6c0607bf7357a0a4690.svg";
export { ForwardRef as ReactComponent };